import { Observable } from 'rxjs';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot,Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ColissessionService } from '../../services/colissession/colissession.service';

@Injectable({
  providedIn: 'root'
})
export class SessionGuard{

  result = false;
  private userprivileges: any;
  constructor(private router: Router, private toastService: ToastrService, private sessionservice: ColissessionService) { }

  // canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<boolean> | Promise<boolean> | boolean> {
  //   let session: any = localStorage.getItem('session');

    // this.sessionservice.getsessiondetail(session).subscribe((response: any) => {
    //   console.log(response?.type);
      // if(response?.type=='' || response?.type==null){
      //   this.sessionservice
      //     .updateSessionType(next.data.type, session)
      //     .subscribe((response: any) => {
      //       this.result= true;
      //     });
      // }

    //   if (response.type == next.data.type) {
    //     console.log(next.data.type)
    //     this.result= true;
    //   }
    //   if(!this.result){
    //     this.toastService.info(
    //       'SVP fermer votre derniere session avant de changer de poste','Session',
    //       {
    //         timeOut: 5000,
    //         progressBar: true,
    //         positionClass: "toast-bottom-right",
    //         enableHtml: true,
    //       }
    //     );
    //     this.result = true;
    //   }
    // });
      // navigate to not found page
    //   return true;
    // }
}
